import { useQuery } from "@tanstack/react-query";
import { CircularProgress, Table, TextChip } from "../../../components/ui";
import { ProcessDashboardRow } from "../../../types/processDashboard";
import { ApointmentStaus, appointmentStatusColors, processStatusColors, ProcessStaus } from "../../../utilities/chipColorSchemas";
import { DashboardServices } from "../../../services/dashboardServices";
import { FilterCitas } from "../../../types";

interface Props {
    filters: FilterCitas;
    pageNumber: number;
    onClick?: (value: ProcessDashboardRow) => void;
}

export function DashboardTable({ filters, pageNumber, onClick }: Props) {
    const dashboardServices = new DashboardServices();

    const { data, isFetching, isError } = useQuery({
        queryKey: ["getDashboardInformation", filters.fechaInicial, filters.fechaFinal, pageNumber],
        queryFn: async () => await dashboardServices.getDashboardInformation({
            fechaInicial: filters.fechaInicial,
            fechaFinal: filters.fechaFinal,
        }, pageNumber),
    });

    if (isFetching)
        return (
        <div className="overflow-auto h-[600px] max-h-[600px] rounded-lg border border-slate-200 z-10">
            <CircularProgress />
        </div>
        );

    if (isError)
        return (
        <div className="overflow-auto h-[600px] max-h-[600px] rounded-lg border border-slate-200 z-10">
            Error al cargar la información, intente más tarde.
        </div>
        );

    return (
        <div className="overflow-auto max-h-[600px] rounded-lg border border-slate-200 z-10">
            <Table>
                <thead>
                    <tr>
                        <th className="w-[90px] text-center">Fecha</th>
                        <th className="w-[90px] text-center">Hora Inicio</th>
                        <th className="w-[90px] text-center">Hora Fin</th>
                        <th>Doctor</th>
                        <th>Paciente</th>
                        <th className="w-[180px] text-center">Tratamiento</th>
                        <th className="w-[120px] text-center">Sucursal</th>
                        <th className="w-[120px] text-center">Status de Cita</th>
                        <th className="w-[120px] text-center">Proceso Actual</th>
                        <th className="w-[180px] text-center">Status del Proceso</th>
                        <th className="w-[70px]"></th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((row, index) => {

                    const statusCitaColors = appointmentStatusColors[row.statusCita as ApointmentStaus];
                    const statusProceso = row.statusProceso ?? "No Iniciado"
                    const processStatusColor = processStatusColors[statusProceso as ProcessStaus]

                    return (
                        <tr key={index} className="hover:bg-slate-50">
                            <td className="text-center">{row.fecha}</td>
                            <td className="text-center">{row.horaInicio}</td>
                            <td className="text-center">{row.horaFin}</td>
                            <td>{row.doctor}</td>
                            <td>{row.paciente}</td>
                            <td className="text-center">{row.tratamiento}</td>
                            <td className="text-center">{row.sucursal}</td>
                            <td className="text-center">
                                <TextChip
                                    size="sm"
                                    text={row.statusCita}
                                    borderColor={statusCitaColors?.borderColor}
                                    bgColor={statusCitaColors?.bgColor}
                                    textColor={statusCitaColors?.textColor}
                                    />
                            </td>
                            <td className="text-center">{row.procesoActual}</td>
                            <td className="text-center">
                                <TextChip
                                    size="sm"
                                    text={statusProceso}
                                    borderColor={processStatusColor?.borderColor}
                                    bgColor={processStatusColor?.bgColor}
                                    textColor={processStatusColor?.textColor} />
                            </td>
                            <td className="text-center"
                                onClick={() => onClick?.(row)}>
                                <p className="m-0 cursor-pointer hover:font-semibold hover:text-blue-500 ">
                                    Detalles
                                </p>
                            </td>
                        </tr>
                    )})}
                </tbody>
            </Table>
        </div>
    );
}

